<template>
  <CCard>
    <CCardBody>
      <h5 class="text-primary">Top 10 Most Applied Programs</h5>
      <div>
        <BasicBar :data="rankedChartData" :height="300" :showLegend="false" />
      </div>
    </CCardBody>
  </CCard>
</template>
<script>
import candidate from "@/containers/KSADashboard/candidate.json";
import BasicBar from "../../components/reusable/Charts/BasicBar.vue";
export default {
  name: "RankedChart",
  components: {
    BasicBar,
  },
  computed: {
    rankedChartData() {
      const colors = ["#1B4965", "#5FA8D3", "#A2D5AB", "#FFC857"];
      const count = candidate.reduce((acc, item) => {
        if (!acc[item.Program]) {
          acc[item.Program] = 0;
        }
        acc[item.Program]++;
        return acc;
      }, {});
      const data = Object.entries(count).map(([name, value]) => ({
        name,
        value,
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
      }));
      const filteredData = data.sort((a, b) => b.value - a.value).slice(0, 10);
      return [
        {
          name: "Most Applied Programs",
          backgroundColor: "#e381da",
          borderColor: "#b000a0",
          values: filteredData,
        },
      ];
    },
  },
};
</script>
